// @flow
export const AboutPageLocale = {
  header: {
    title: ["About Us", "Hakkımızda"],
    content: [
      "Envanterium was founded in 2017 to provide technology-based inventory counting services, with an experience of 10 years in the area. With our constantly improving product we keep improving the stock counting processes for many establishments",
      "2017 yılında teknoloji odaklı envanter sayım hizmeti için kurulan Envanterium, bu alanda 10 yılı aşkın bir tecrübe birikiminin eseridir. Sürekli geliştirmekte olduğumuz ürünümüzle birçok firmanın sayım sürecini kolaylaştırmaya devam ediyoruz."
    ]
  },
  mission: {
    header: {
      title: ["Our Mission", "Görevimiz"],
      content: [
          "With our 10+ years of experience and our solution partners, we take it our mission to develop and provide the smoothest inventory counting processes your establishment has experienced.",
          "Envanter sayımında 10+ yılı aşkın tecrübemiz ve çözüm ortaklarımızla firmanız için tarihinin en sorunsuz envanter sayım süreçlerini geliştirmeyi ve gerçekleştirmeyi görevimiz olarak adlandırıyoruz."
      ]
    },
    items: {
      one: [
          "Merging technology with inventory counting processes that still work highly manually even today.",
          "Günümüzde hala oldukça manuel işleyen sayım süreçleriyle teknolojiyi bir araya getirmek."
      ],
      two: [
          "Developing our products for your inventory counting and analyses according to your needs, with a purpose of quick and correct results.",
          "Sayım ve raporlarınız için ürünlerimizi firmanızın ihtiyaçlarına uygun, hızlı ve doğru sonuca yönelik geliştirmek."
      ],
      three: [
          "Providing educated and qualified personnel for your inventory counting operations.",
          "Sayım elemanı ihtiyacınızı eğitimli ve kalifiyeli elemanlarla sağlamak"
      ],
      four: [
          "Organizing and completing inventory counting operations in a controlled way within reasonable times.",
          "Sabahlara kadar süren sayımlar yerine zamanında ve kontrollü tamamlanan sayım hizmetleri sunmak"
      ],
    }
  },
  counters: {
    finished: ["PROJECT", "SAYIM"],
    customers: ["CUSTOMER", "MÜŞTERİ"],
    satisfaction: ["CUSTOMER SATISFACTION", "MÜŞTERİ MEMNUNİYETİ"]
  }
};



// WEBPACK FOOTER //
// ./src/Locales/PublicPages/AboutPage.locale.js